import { createStore } from 'redux';

// Initial state
const initialState = {
  // valueFromHeader: ''
  valueFromHeader: {
    walletAddress: "",
    provider: "",
  },
};

// Actions
const SET_VALUE = 'SET_VALUE';

export const setValue = (value) => ({
  type: SET_VALUE,
  payload: value
});

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE:
      return {
        ...state,
        valueFromHeader: action.payload
      };
    default:
      return state;
  }
};

// Create store
const store = createStore(reducer);

export default store;
